import React from 'react';
import { ToggleWrapper } from './ToggleItem.styles';
import { TextV2, TextV2Props } from '@withjoy/joykit';
import classNames from 'classnames';

export interface ToggleItemProps
  extends Readonly<{
    label: string;
    value: string;
    onClick?: React.MouseEventHandler<HTMLAnchorElement>;
    isActive?: boolean;
    isDisabled?: boolean;
    isMobile?: boolean;
    textProps?: TextV2Props;
  }> {}

const ToggleItem: React.FC<ToggleItemProps> = ({ onClick, isActive, value, isMobile, textProps = {}, isDisabled }) => {
  return (
    <ToggleWrapper
      as="a"
      isMobile={isMobile}
      onClick={isDisabled ? undefined : onClick}
      className={classNames({ active: isActive, disabled: isDisabled })}
    >
      <TextV2
        typographyVariant="body1"
        color={isActive ? 'mono14' : 'mono10'}
        {...textProps}
      >
        {value}
      </TextV2>
    </ToggleWrapper>
  );
};

export { ToggleItem };
